/**
 * 图片搜索跨页传参与预加载工具
 */

/** @type {File[]|null} */
let pendingFiles = null

/** @type {Promise|null} */
let prefetchPromise = null

/** @type {boolean} */
let prefetchResolved = false

/**
 * 暂存待上传的图片文件（内存直传，避免 sessionStorage + blob 中转）
 * @param {FileList|File[]} files - 用户选择的文件
 */
export function setPendingImageFiles(files) {
  pendingFiles = Array.from(files)
}

/**
 * 取出并清空暂存的图片文件
 * @returns {File[]|null}
 */
export function consumePendingImageFiles() {
  const files = pendingFiles
  pendingFiles = null
  return files
}

/**
 * 预加载图片搜索页 chunk
 * @returns {Promise}
 */
export function prefetchImageSearchPage() {
  if (!prefetchPromise) {
    prefetchPromise = import(/* webpackPrefetch: true */ '@/views/imageSearch/index.vue')
      .then((module) => {
        prefetchResolved = true
        return module
      })
  }
  return prefetchPromise
}

/**
 * 图片搜索页 chunk 是否已预加载完成
 * @returns {boolean}
 */
export function isImageSearchPagePrefetched() {
  return prefetchResolved
}
